import { useEffect, useRef } from 'react';
import ScrollBooster from 'scrollbooster';

export const useScrollBooster = (viewportRef, options, onScroll) => {
  const scrollboosterRef = useRef(null);

  useEffect(() => {
    if (!viewportRef.current || scrollboosterRef.current) return;

    const booster = new ScrollBooster({
      viewport: viewportRef.current,
      ...options,
      onUpdate: (data) => {
        onScroll(data);
      },
    });

    scrollboosterRef.current = booster;

    return () => booster.destroy();
  }, [viewportRef, options, onScroll]);

  return scrollboosterRef.current;
}
